<div class="task-list__header">
  @if (!isAllProject()) {
  <div class="task-list__left task-list__left_center">
    <div class="task-list__plus-btn" [class.task-list__plus-btn_open]="isOpenCreateForm()"
      (click)="onToggleCreateForm()">
      <i class="icon-plus"></i>
    </div>
  </div>
  }

  <div class="task-list__right">
    <div class="task-list__group-controls">
      <app-group-dropdown [groupMode]="groupMode()" (groupModeChange)="onToggleGroupMode($event)"></app-group-dropdown>
    </div>
    @if (backlogStatus()?.name; as name) {
    <div class="task-list__toggle-back-log" [class.task-list__toggle-back-log_active]="isShowBacklog()"
      (click)="onToggleBacklog()">
      <svg class="task-list__toggle-icon" width="17" height="17" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="#B3BFC9" fill-rule="evenodd"
          d="M17.09 10.82c-.75 0-1.41-.03-1.96-.1-1.06-.13-1.85-.99-1.91-2.09-.02-.41-.04-.97-.04-1.73s.02-1.32.04-1.73c.06-1.1.85-1.96 1.91-2.09 1.09-.13 2.83-.13 3.92 0 1.06.13 1.85.99 1.91 2.09.02.41.04.97.04 1.72s-.02 1.32-.04 1.73c-.06 1.1-.85 1.96-1.91 2.09-.54.07-1.2.1-1.96.1v.01Zm0-5.82c-.67 0-1.25.03-1.72.08-.05 0-.15.02-.16.21-.02.38-.04.9-.04 1.61 0 .71.02 1.23.04 1.61.01.191.101.209.153.219l.007.001c.93.11 2.51.11 3.44 0 .05 0 .15-.02.16-.21.02-.38.04-.9.04-1.61 0-.71-.02-1.23-.04-1.61-.01-.191-.101-.209-.153-.219l-.007-.001c-.47-.06-1.04-.08-1.72-.08ZM4.95 10.72c.55.07 1.21.1 1.96.1.76 0 1.41-.03 1.96-.1 1.06-.13 1.85-.99 1.91-2.09.02-.4.04-.97.04-1.72s-.02-1.31-.04-1.72c-.06-1.1-.85-1.96-1.91-2.09-1.09-.13-2.82-.13-3.92 0-1.06.13-1.85.99-1.91 2.1-.02.4-.04.97-.04 1.72s.02 1.31.04 1.72c.06 1.1.85 1.95 1.91 2.08Zm.24-5.64C5.66 5.03 6.24 5 6.91 5c.68 0 1.25.02 1.72.08.05 0 .15.01.16.21.02.38.04.9.04 1.61 0 .71-.02 1.23-.04 1.61-.01.19-.11.21-.16.21-.94.11-2.51.11-3.44 0-.05 0-.15-.01-.16-.21-.02-.38-.04-.9-.04-1.61 0-.71.02-1.23.04-1.61.01-.19.11-.21.16-.21Zm-.24 15.7c.55.07 1.21.1 1.96.1s1.41-.03 1.96-.1c1.06-.13 1.85-.99 1.91-2.09.02-.4.04-.97.04-1.72s-.02-1.31-.04-1.72c-.06-1.11-.85-1.96-1.91-2.09-1.09-.13-2.84-.13-3.92 0-1.06.13-1.85.99-1.91 2.09-.02.4-.04.97-.04 1.72s.02 1.31.04 1.72c.06 1.1.84 1.96 1.91 2.09Zm.24-5.65c.47-.05 1.04-.08 1.72-.08v-.01c.68 0 1.25.03 1.72.09.06 0 .15.01.16.21.02.38.04.9.04 1.61 0 .71-.02 1.23-.04 1.61-.02.19-.11.21-.16.21-.94.11-2.5.11-3.44 0-.05 0-.15-.01-.16-.21-.02-.38-.04-.9-.04-1.61 0-.71.02-1.23.04-1.61.01-.19.11-.21.16-.21Zm9.94 5.65c.55.07 1.21.1 1.96.1l.01-.01c.75 0 1.41-.03 1.96-.1 1.06-.13 1.85-.99 1.91-2.09.02-.41.04-.97.04-1.73s-.02-1.31-.04-1.72c-.06-1.11-.85-1.96-1.91-2.09-1.09-.13-2.84-.13-3.92 0-1.07.13-1.86.99-1.92 2.09-.02.41-.04.97-.04 1.73s.02 1.32.04 1.73c.06 1.1.84 1.96 1.91 2.09Zm.24-5.65c.47-.05 1.04-.08 1.72-.08v-.01c.68 0 1.25.03 1.72.09.05 0 .15.01.16.21.02.38.04.9.04 1.61 0 .71-.02 1.23-.04 1.61-.02.19-.11.21-.16.21-.94.11-2.51.11-3.44 0-.05 0-.15-.01-.16-.21-.02-.38-.04-.9-.04-1.61 0-.71.02-1.23.04-1.61.01-.19.11-.21.16-.21Z"
          clip-rule="evenodd" />
      </svg>
      {{ name }}
    </div>
    }

    <app-filter-controls></app-filter-controls>
  </div>
</div>
<div class="task-list__tasks">
  @if (isOpenCreateForm()) {
  <div class="task-list__task task-list__task_active" (clickOutside)="onCloseCreateForm()"
    [delayClickOutsideInit]="true">
    <div class="task-list__item">
      <div class="task-list__name">
        <input #taskInput type="text" placeholder="Введите название задачи" [ngModel]="model().name"
          (ngModelChange)="onUpdateModelName($event)" (keydown.enter)="onCreate()" />
      </div>
    </div>
  </div>
  }

  <ng-template #taskItemTemplate let-taskModel let-isActive="isActive">
    <div class="task-list__task" [class.task-list__task_active]="isActive" draggable="true"
      (dragstart)="onDragStart($event, taskModel)" (dragend)="onDragEnd($event)"
      (click)="onTaskClick(taskModel, $event)">
      <div class="task-list__item">
        <div class="task-list__name" [class.task-list__name_archive]="taskModel.isArchive">
          {{ taskModel.name }}
        </div>
        <div class="task-list__right">
          @for (tag of taskModel.tagList ? taskModel.tagList.slice(0, 2) : []; track tag.name) {
          <ux-tag class="task-list__tag" [model]="tag" (click)="onFilterByTag(tag, $event)"></ux-tag>
          }
          <ux-status class="status_fs12 task-list__status" [status]="taskModel.status"
            (click)="onFilterByStatus(taskModel.status, $event)"></ux-status>
          <ux-avatar [user]="taskModel.responsible?.user" (click)="onFilterByUser(taskModel.responsible?.user, $event)"
            style="width: 29px; height: 29px"></ux-avatar>
        </div>
      </div>
    </div>
  </ng-template>

  @if (groupMode() === 'none') {
  @for (taskModel of itemsShow$(); track taskModel.id) {
  <ng-container
    *ngTemplateOutlet="taskItemTemplate; context: { $implicit: taskModel, isActive: taskModel.id === openTaskId() }"></ng-container>
  }
  } @else {
  @for (group of groupedTasks(); track group.name) {
  <div class="task-list__group-header" (click)="onToggleGroup(group.key)">
    <div class="task-list__group-title">
      <svg class="task-list__caret-icon" [class.task-list__caret-icon_expanded]="!isGroupCollapsed(group.key)"
        width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M6.948 8.34c-.953.166-1.249 1.301-.605 2.183.463.632 1.1 1.454 1.967 2.483 1.043 1.238 1.865 2.026 2.466 2.523.759.628 1.69.628 2.448 0 .601-.497 1.423-1.285 2.466-2.523a46.21 46.21 0 0 0 1.967-2.483c.644-.881.348-2.017-.605-2.183C16.022 8.16 14.423 8 12 8c-2.423 0-4.021.16-5.052.34Z" />
      </svg>
      {{ group.name || 'Untagged' }}:
      <span class="task-list__group-count">{{ group.tasks.length }}</span>
    </div>
  </div>

  @if (!isGroupCollapsed(group.key)) {
  <div class="task-list__group-content">
    @for (taskModel of group.tasks; track taskModel.id) {
    <ng-container *ngTemplateOutlet="
                taskItemTemplate;
                context: { $implicit: taskModel, isActive: taskModel.id === openTaskId() }
              "></ng-container>
    }
  </div>
  }
  }
  }
</div>